import { http } from "./http";

export interface HospitalOption {
  value: string;
  label: string;
  labelEn: string;
}

export interface AuthUser {
  usrid: string;
  name: string | null;
  role: string;
  hospId: number;
  hospName: string | null;
  mustChangePassword: boolean;
}

export interface LoginResponse {
  accessToken: string;
  refreshToken?: string;
  user: AuthUser;
}

export const authApi = {
  hospitals(): Promise<HospitalOption[]> {
    return http.get<HospitalOption[]>("/auth/hospitals").then((r) => r.data);
  },
  login(username: string, password: string): Promise<LoginResponse> {
    return http
      .post<LoginResponse>("/auth/login", { username, password })
      .then((r) => r.data);
  },
  refresh(refreshToken?: string): Promise<LoginResponse> {
    return http.post<LoginResponse>("/auth/refresh", { refreshToken }).then((r) => r.data);
  },
  logout(refreshToken?: string): Promise<void> {
    return http.post<void>("/auth/logout", { refreshToken }).then((r) => r.data);
  },
  me(): Promise<AuthUser & { sub: string; scope: string }> {
    return http
      .get<AuthUser & { sub: string; scope: string }>("/auth/me")
      .then((r) => r.data);
  },
  changePassword(currentPassword: string, newPassword: string): Promise<void> {
    return http
      .post<void>("/auth/change-password", { currentPassword, newPassword })
      .then((r) => r.data);
  },
};
